export default {"src":"https://fishbrain.com/_next/static/media/logo.135104ef.svg","height":116,"width":551,"blurWidth":0,"blurHeight":0};